<template>
  <div class="button-edit">
    <style-bar :css-keys="['background', 'color']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>

    <v-text-field class="text-field mt-2 pt-5 px-2" hide-details placeholder="Buy Now!" v-model="form.content" :label="$t('button_text')"></v-text-field>
    <!-- <v-text-field class="pt-5" hide-details @input="updateUrl()" v-model="btnUrl" label="Button Link"></v-text-field> -->
    <!-- 'content', 'label', 'placeholder', 'mode' -->
    <rich-text-input class="py-2 px-2" placeholder="https://www.example.com/" :content.sync="form.url" mode="url" :json.sync="editorContentJson" :label="$t('button_link')"></rich-text-input>
  </div>
</template>

<script>

import RichTextInput from '@/components/utils/RichTextInput'
import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'ButtonEdit',
  props: ['content', 'url', 'styles'],
  components: {
    'rich-text-input': RichTextInput,
    StyleBar
  },
  watch: {
    styles (newVal) {
      this.localStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}
    }
  },
  data () {
    return {
      form: {
        content: '',
        url: ''
      },
      localStyles: {},
      editorContentJson: {}
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }
    this.form.url = this.url

    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  }
}
</script>

<style lang="sass" scoped>

.button-edit
  background: #f1f1f1

.text-field
  background: white

</style>
